import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  IconButton,
  useScrollTrigger,
  Slide,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import BusinessIcon from "@mui/icons-material/Business";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import logo from "../../Assets/logo.png"; // استيراد الشعار من assets (تأكد من وجود الملف في هذا المسار)

// Styled components for professional look
const StyledAppBar = styled(AppBar)(({ theme }) => ({
  // استخدمنا #f57226 كلون رئيسي في التدرّج
  background:
    "linear-gradient(135deg, #f57226 0%, #ff9b4a 50%, #f57226 100%)",
  boxShadow: "0 8px 32px rgba(245,114,38,0.28)",
  backdropFilter: "blur(10px)",
  borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
}));

const StyledToolbar = styled(Toolbar)({
  minHeight: "70px",
  padding: "0 24px",
  justifyContent: "space-between",
});

const LogoBox = styled(Box)({
  display: "flex",
  alignItems: "center",
});

const NavButton = styled(IconButton)(({ theme }) => ({
  color: "white",
  marginLeft: "12px",
  padding: "10px",
  borderRadius: "12px",
  transition: "all 0.3s ease",
  "&:hover": {
    // ظل Hover بسيط بلون البرتقالي المطلوب
    backgroundColor: "rgba(245,114,38,0.12)",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
  },
}));

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

// الآن يقبل props.appName و props.logoSrc مع قيم افتراضية
const UserNavbar = ({ isOpen, drawerWidth, collapsedWidth, appName = "لوحة تحكم تطبيق ريستو كاش", logoSrc = logo }) => (
  <HideOnScroll>
    <StyledAppBar
      position="fixed"
      elevation={0}
      sx={{
        width: isOpen
          ? `calc(100% - ${drawerWidth}px)`
          : `calc(100% - ${collapsedWidth}px)`,
        transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        left: 0,
        right: "auto",
      }}
    >
      <StyledToolbar>
        <LogoBox>
          {/* عرض الشعار من assets إن وُجد، وخلفية اللوجو بيضاء دائماً */}
          <Avatar
            src={logoSrc}
            alt={appName}
            sx={{
              bgcolor: "#ffffff", // خلفية بيضاء دائماً
              mr: 2,
              width: 45,
              height: 45,
              border: "2px solid rgba(0,0,0,0.06)", // حد فاتح يظهر على الأبيض
            }}
          >
            {/* إذا لم توجد صورة الشعار، عرض أيقونة برتقالية لتتناسب مع اللون الرئيسي */}
            {!logoSrc && <BusinessIcon sx={{ color: "#f57226", fontSize: "1.5rem" }} />}
          </Avatar>

          <Typography
            variant="h5"
            component="div"
            sx={{
              fontWeight: "700",
              color: "#ffffff",          // اجعل النص أبيض ثابتاً
              textShadow: "0 2px 4px rgba(0,0,0,0.15)",
            }}
          >
            {appName}
          </Typography>
        </LogoBox>

        <Box sx={{ display: "flex", alignItems: "center" }}>

          <NavButton>
            <AccountCircleIcon />
          </NavButton>
        </Box>
      </StyledToolbar>
    </StyledAppBar>
  </HideOnScroll>
);

export default UserNavbar;
